import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

const NegativeImpact = () => {
  const { theme } = useSelector((state) => state.theme);
  const navigate = useNavigate();
  const { id } = useParams();

  const handleYes = () => navigate(`/unsubscribe/${id}/confirm`);
  const handleNo = () => navigate('/');

  const impacts = [
    { title: "Premium Content", description: "Lose access to all exclusive trading insights and analysis.", icon: "💎" },
    { title: "Saved Preferences", description: "All your custom settings and watchlists will be reset.", icon: "⚙️" },
    { title: "Priority Support", description: "You will no longer have access to our 24/7 priority help desk.", icon: "🆘" },
    { title: "Community Channels", description: "You will be removed from all private trader groups.", icon: "🤝" },
  ];

  return (
    <div className={`flex-1 flex flex-col items-center justify-center p-4 sm:p-6 min-h-[calc(100vh-150px)] ${theme === 'dark' ? 'bg-slate-900 text-slate-200' : 'bg-slate-50 text-slate-900'}`}>
      <div className={`w-full max-w-2xl ${theme === 'dark' ? 'bg-slate-800/50 border-slate-700/50' : 'bg-white border-slate-100'} backdrop-blur-xl rounded-[2rem] p-6 sm:p-10 shadow-2xl border`}>
        <div className="flex items-center gap-3 mb-8">
          <div className="h-8 w-1.5 bg-red-600 rounded-full" />
          <h2 className={`text-2xl sm:text-3xl font-bold tracking-tight ${theme === 'dark' ? 'text-slate-100' : 'text-slate-900'}`}>Important Notice</h2>
        </div>

        <div className="space-y-8">
          <p className={`text-base sm:text-lg font-medium ${theme === 'dark' ? 'text-slate-300' : 'text-slate-700'}`}>
            By unsubscribing, you will lose access to several premium benefits:
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {impacts.map((impact, index) => (
              <div key={index} className={`p-5 rounded-2xl border transition-all duration-300 ${
                theme === 'dark' ? 'bg-slate-900/40 border-slate-700/50 hover:border-red-500/30' : 'bg-slate-50 border-slate-100 hover:border-red-200'
              }`}>
                <div className="flex items-start gap-4">
                  <span className="text-2xl mt-1">{impact.icon}</span>
                  <div className="space-y-1">
                    <h3 className={`font-bold text-sm ${theme === 'dark' ? 'text-slate-100' : 'text-slate-900'}`}>{impact.title}</h3>
                    <p className={`text-xs leading-relaxed ${theme === 'dark' ? 'text-slate-400' : 'text-slate-500'}`}>{impact.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className={`p-6 rounded-2xl border-2 border-dashed ${theme === 'dark' ? 'bg-red-500/5 border-red-500/20' : 'bg-red-50 border-red-100'}`}>
            <p className={`text-base font-bold text-center ${theme === 'dark' ? 'text-red-400' : 'text-red-600'}`}>
              Do you still want to proceed with unsubscription?
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 pt-4">
            <button
              onClick={handleYes}
              className="flex-1 py-4 bg-red-600 hover:bg-red-700 text-white font-bold text-xs uppercase tracking-widest rounded-2xl shadow-lg shadow-red-600/20 transition-all duration-300 active:scale-95"
            >
              Yes, Continue
            </button>
            <button
              onClick={handleNo}
              className={`flex-1 py-4 font-bold text-xs uppercase tracking-widest rounded-2xl transition-all duration-300 active:scale-95 border-2 ${
                theme === 'dark' 
                  ? 'bg-slate-800 text-slate-200 border-slate-700 hover:bg-slate-700' 
                  : 'bg-white text-slate-600 border-slate-100 hover:bg-slate-50 shadow-sm'
              }`}
            >
              No, Take Me Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NegativeImpact;
